import * as React from 'react'

export const formatAmount = (amount: number, decimals: number) => {
	const amountFixed = amount.toFixed(decimals)
	var rounded = parseFloat(amountFixed).toString()
	var lastZeros = amountFixed.replace(rounded, '')
	return (<span>{rounded}<span className='grayZero'>{lastZeros}</span></span>)
}